import React, { useId, useRef } from 'react';
import useCamada from './useCamada';

/**
 * Dialogo — janela modal de decisão. Esc e clique no véu fecham; o foco entra no
 * primeiro controle ao abrir e volta para quem abriu ao fechar.
 *
 * titulo é uma pergunta direta; o botão de confirmação repete o verbo ("Excluir prazo").
 * largura: 'padrao' (440px) | 'media' (560px) | 'larga' (680px), para listas e tabelas dentro do diálogo;
 * 'cheia' (1120px) para uma prévia de página inteira.
 */
export default function Dialogo({ aberto, onFechar, titulo, texto, acoes, largura = 'padrao', children }) {
  const gerado = useId();
  const tituloId = `dialogo-${gerado}-titulo`;
  const caixa = useRef(null);
  useCamada(aberto, onFechar, caixa);

  if (!aberto) return null;

  return (
    <div className="sj-veu" onMouseDown={(e) => { if (e.target === e.currentTarget) onFechar?.(); }}>
      <div ref={caixa} className={largura === 'padrao' ? 'sj-dialogo' : `sj-dialogo sj-dialogo--${largura}`} role="dialog" aria-modal="true" aria-labelledby={tituloId}>
        <h2 id={tituloId} className="sj-dialogo__titulo">{titulo}</h2>
        {texto && <p className="sj-dialogo__texto">{texto}</p>}
        {children}
        {acoes && <div className="sj-dialogo__acoes">{acoes}</div>}
      </div>
    </div>
  );
}
